export const zones = [
  {
    bgColor: "#2b446b",
    text: [
      {
        title: "Future zone",
        subtitle: "Ovo nije",
        text: "Ovo je mesto gde je neko prvi put izgovorio ono što će postati uvod u njegov TED Talk.",
      },
      {
        title: "Multidisciplinarni prostor za kreativna i tehnološka rešenja",
        text: <>U ovoj zoni učenici razvijaju veštine timskog rada, kreativnog mišljenja i rešavanja problema kroz multidisciplinarne zadatke. Savremeni prostor za prezentacije i projekcije opremljen je modernim gledalištem i projekcionim zidom.<br /><br />Zahvaljujući mobilnoj bini i inovativnom prostornom rešenju, zona omogućava različite formate javnog nastupa i kreativnog izražavanja.</>,
        list: ["76 m²", "aktivna zona", "kolektivno"]
      },
    ],
  },
  {
    bgColor: "#f7b815",
    text: [
      {
        title: "Classroom zone",
        subtitle: "Ovo nije",
        text: "Ovo je mesto gde je neko prvi put preuzeo odgovornost za ceo tim.",
      },
      {
        title: "Učionice koje prate ritam savremenog učenja",
        text: <>Učionice su opremljene u skladu sa savremenim standardima, kombinuju funkcionalan raspored i tehničku podršku za različite oblike nastave.<br /><br />Digitalna opremljenost i pažljivo birani elementi enterijera omogućavaju lako prilagođavanje različitim nastavnim formatima i metodama rada. Savremeni uslovi doprinose produktivnijem učenju, većoj mentalnoj prisutnosti i boljoj organizaciji časa.</>,
        list: [<>247 m² / <br />6 učionica</>, "interaktivna zona", "u grupama"]
      },
    ],

  },
  {
    bgColor: "#427042",
    text: [
      {
        title: "Innovation zone",
        subtitle: "Ovo nije",
        text: "Ovo je mesto gde se neko prvi put zapitao zašto ovako nešto već ne postoji. I uz AI napravio prototip. A sada ga svi koristimo.",
      },
      {
        title: "Prostor za inovacije kroz savremene tehnologije i timsku dinamiku",
        text: <>Innovation zone sastoji se iz niza manjih ambijenata prilagođenih timskom radu, razmeni znanja i praktičnoj primeni različitih oblasti na način koji podstiče rešavanje problema i primenu znanja kroz savremene tehnologije i interdisciplinarni pristup.<br /><br />Prostor uključuje interaktivne zidne površine, brejnstorming zonu i studio osmišljen da podstakne inovativno razmišljanje i saradnju.</>,
        list: ["126 m²", "aktivna zona", <>
          individualno /<br />u malim grupama
        </>]
      },
    ],
  },
  {
    bgColor: "#9d1516",
    text: [
      {
        title: "Reading zone",
        subtitle: "Ovo nije",
        text: "Ovo je mesto gde je neko prvi put poželeo da pročita još jedno poglavlje – iako ga je društvo čekalo ispred škole.",
      },
      {
        title: "Mirna zona za čitanje, učenje i koncentraciju",
        text: <>Reading zone predstavlja savremeno uređeni prostor biblioteke namenjen tišini, samostalnom radu i čitanju. Opremljen je različitim tipovima elemenata za sedenje koji omogućavaju učenicima da pronađu ambijent koji im najviše odgovara – za učenje u ritmu koji sami određuju.<br /><br />Ovde se razvijaju fokus, strpljenje i sposobnost razumevanja pročitanog – veštine koje su ključne za uspeh u svakom savremenom obrazovnom okruženju.</>,
        list: ["33 m²", "tiha zona", <>individualno / <br />u malim grupama</>]
      },
    ],
  }
];